import Api from "~/service/Api";

class CustomerRepository {
  fetch(query) {
    return Api.get("/customers", query);
  }

  create(data) {
    return Api.post("/customers", data);
  }

  fetchOne(customerId) {
    return Api.get(`/customers/${customerId}`);
  }

  update(customerId, data) {
    return Api.put(`/customers/${customerId}`, data);
  }
}

export default CustomerRepository;
